import { DeleteSharp, EditSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  insertOBTQuestions,
  updateOBTQuestions,
  deleteOBTQuestions,
  getOBTQuestions
} from "src/api/commonapi";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function OBTQuestions() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [addEditModal, setAddEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [obtQuestionData, setOBTQuestionData] = useState({
    obt_question: ""
  });
  const [tableData, setTableData] = useState([]);
  const toggleAddEditModal = () => setAddEditModal(!addEditModal);
  const resetFormData = () => {
    setOBTQuestionData({
      obt_question: ""
    });
  };
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [response, setresponse] = useState(0);

  const handleSubmit = async (newData = undefined) => {
    if (newData != undefined ? newData : obtQuestionData.obt_que_id != undefined) {
      // update
      if ((newData != undefined ? newData : obtQuestionData).obt_question != "") {
        let fnData = new FormData();
        fnData.append(
          "obt_que_id",
          newData != undefined ? newData.obt_que_id : obtQuestionData.obt_que_id
        );
        fnData.append(
          "obt_question",
          newData != undefined ? newData.obt_question : obtQuestionData.obt_question
        );

        setIsLoading(true);
        let resp = await updateOBTQuestions(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          newData == undefined && toggleAddEditModal();
          getOBTQuestionsData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    } else {
      // Insert
      if (obtQuestionData.obt_question != "") {
        let fnData = new FormData();
        fnData.append("obt_question", obtQuestionData.obt_question);
        setIsLoading(true);
        let resp = await insertOBTQuestions(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          getOBTQuestionsData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    }
  };
  const deleteOBTQuestionData = async (obt_que_id) => {
    const resp = await deleteOBTQuestions(obt_que_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };
  const getOBTQuestionsData = async () => {
    setIsLoading(true);
    let res = await getOBTQuestions();
    setIsLoading(false);
    setTableData(res);
  };
  useEffect(() => {
    getOBTQuestionsData();
  }, [response]);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.obt_que_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.obt_question,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      selector: (row) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                setOBTQuestionData({
                  obt_question: row.obt_question,
                  obt_que_id: row.obt_que_id
                });
                toggleAddEditModal();
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                setDvisible({ mval: true, id: row.obt_que_id });
              }}
            >
              <DeleteSharp color="error" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deleteOBTQuestionData} />

      <Page title="LVB OBT Questions | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  OBT Questions
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => (toggleAddEditModal(), resetFormData())}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add OBT Question
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => (toggleAddEditModal(), resetFormData())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Add OBT Question
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid container>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="OBT Question"
                      name="obt_question"
                      placeholder="Enter OBT Question"
                      onChange={(e) => {
                        setOBTQuestionData({
                          ...obtQuestionData,
                          obt_question: e.target.value
                        });
                      }}
                      value={obtQuestionData?.obt_question}
                    />
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => (toggleAddEditModal(), resetFormData())}
                      style={{ marginTop: "15px", marginRight: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      onClick={() => handleSubmit()}
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Modal>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
